import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { removeStoredAuthData as clearAdfsSession, getStoredAuthData } from "@/services/auth/adfs.service";
import { AuthData } from "@/services/auth/auth.types";
import { clearEntraIdSession } from "@/services/auth/entra-id.service";

export interface AuthState {
    accessToken?: string;
    isAuthenticated: boolean;
    authStrategy: "adfs" | "entraId" | null;
}

let initialState: AuthState = { isAuthenticated: false, authStrategy: null };

const storedAuthData = getStoredAuthData();
if (storedAuthData) {
    initialState = {
        accessToken: storedAuthData.accessToken,
        isAuthenticated: true,
        authStrategy: "adfs",
    };
}

const authSlice = createSlice({
    name: "auth",
    initialState,
    reducers: {
        authenticate: (
            state,
            action: PayloadAction<{ authStrategy: "adfs"; authData: AuthData } | { authStrategy: "entraId" }>,
        ) => {
            if (action.payload.authStrategy === "adfs") {
                state.accessToken = action.payload.authData.accessToken;
                clearEntraIdSession();
            } else if (action.payload.authStrategy === "entraId") {
                state.accessToken = undefined;
                clearAdfsSession();
            }
            state.isAuthenticated = true;
            state.authStrategy = action.payload.authStrategy;
        },
        logout: (state) => {
            state.accessToken = undefined;
            state.isAuthenticated = false;
            state.authStrategy = null;

            clearEntraIdSession();
            clearAdfsSession();
        },
    },
});

export const { authenticate, logout } = authSlice.actions;
export const authReducer = authSlice.reducer;
